import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useRef } from "react";
import {
  Pole,
  getCurrentTechnoOrDisconnect,
} from "../../../variables/jobDictionnary";
import StatsPoleTechnologie from "./StatsPoleTechnologie";
import StatsPoleTutorials from "./StatsPoleTutorials";

interface Props {
  pole: Pole;
  genre: string;
}

const StatModal: React.FC<Props> = ({ pole, genre }) => {
  const modal = useRef<HTMLIonModalElement>(null);

  return (
    <>
      <IonButton
        id={"open-modal" + getCurrentTechnoOrDisconnect() + pole.number + genre}
        shape="round"
        style={{ width: "100%" }}
      >
        {pole.name}
      </IonButton>
      <IonModal
        ref={modal}
        trigger={
          "open-modal" + getCurrentTechnoOrDisconnect() + pole.number + genre
        }
      >
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => modal.current?.dismiss()}>
                Retour
              </IonButton>
            </IonButtons>
            <IonTitle>Résultats de {pole.name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          {genre === "techno" ? (
            <StatsPoleTechnologie
              pole={pole.number}
              type={getCurrentTechnoOrDisconnect()}
            />
          ) : (
            <StatsPoleTutorials
              pole={pole.number}
              type={getCurrentTechnoOrDisconnect()}
            />
          )}
        </IonContent>
      </IonModal>
    </>
  );
};

export default StatModal;
